import * as actions from '../actions';
import { CoreState } from '../types';

type Handler<A extends keyof typeof actions> = (
  state: CoreState,
  action: ReturnType<(typeof actions)[A]>,
) => CoreState;

export const setLoggedUser: Handler<'setLoggedUser'> = (state, action) => {
  return {
    ...state,
    user: action.payload,
  };
};

export const cleanLoggedUser: Handler<'cleanLoggedUser'> = state => {
  return {
    ...state,
    user: undefined,
  };
};
